import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Fullpage Error Component (F-MINIERRBG)
 *
 * Teljes képernyős hibaképernyő a miniappokhoz, a legacy értesítő/hibaoldalak
 * kinézetével: NoticeBg háttér (admin által feltöltött kép/videó a poolból,
 * vagy animált lila gradient + canvas pontmező) és rajta az üzenet
 * üveg-kártyán.
 *
 * A háttér-adat alapból a shell (miniapp.tpl) által SSR-ben injektált
 * window.__MINIAPP_NOTICE_BG__ változóból jön — így hálózati/API-hiba esetén
 * is van háttér, extra HTTP kérés nélkül. A `bg` proppal felülírható.
 */
import React from 'react';
import { NoticeBg } from './NoticeBg';
import './FullpageError.scss';
/** A shell által injektált háttér-adat (hiányzó/hibás érték esetén null). */
export function getMiniappNoticeBg() {
    if (typeof window === 'undefined') {
        return null;
    }
    const bg = window.__MINIAPP_NOTICE_BG__;
    if (!bg || typeof bg !== 'object' || !bg.url) {
        return null;
    }
    return bg;
}
export function FullpageError({ message, title, icon, code, onRetry, retryLabel, testId, bg, }) {
    const bgData = bg === undefined ? getMiniappNoticeBg() : bg;
    const resolvedTitle = title === undefined ? 'Hiba történt' : title;
    return (_jsxs("div", { className: "miniapp-fullpage-error", "data-testid": testId, children: [_jsx(NoticeBg, { imageUrl: bgData ? bgData.url : null, type: bgData ? bgData.type : null }), _jsxs("div", { className: "miniapp-fullpage-error-card", role: "alert", children: [_jsx("i", { className: `miniapp-fullpage-error-icon ${icon || 'fas fa-exclamation-triangle'}`, "aria-hidden": "true" }), resolvedTitle !== '' && _jsx("h2", { children: resolvedTitle }), _jsx("p", { className: "miniapp-fullpage-error-message", children: message }), code !== undefined && code !== null && code !== '' && (_jsxs("p", { className: "miniapp-fullpage-error-code", children: ["Hibak\u00F3d: ", code] })), onRetry && (_jsx("button", { type: "button", className: "miniapp-fullpage-error-retry", onClick: onRetry, children: retryLabel || 'Újrapróbálás' }))] })] }));
}
